import React, { useEffect, useState } from 'react';
import { Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import MeterForm from '../components/MeterForm';
import { useMutateMeterHandler } from '../dataHandlers/mutateMeterHandler';

export default function MeterCreatePage() {
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { onSubmit, error, isPending } = useMutateMeterHandler({
    onSuccess: () => navigate('/meters'),
  });

  useEffect(() => {
    if (!isPending && isSubmitting) setIsSubmitting(false);
  }, [isPending, isSubmitting]);

  return (
    <Stack direction="column" sx={{ mt: '-2rem' }}>
      <MeterForm
        onSubmit={(payload) =>
          onSubmit(
            {
              display_name: payload.display_name,
              event_name: payload.event_name,
              active: true,
            },
            false,
          )
        }
        onCancel={() => navigate('/meters')}
        initialData={{
          display_name: '',
          event_name: '',
          aggregation_formula: 'sum',
        }}
        apiErrors={error}
        isLoading={isPending || isSubmitting}
      />
    </Stack>
  );
}
